export const statusOptions = [
  { key: 1, text: 'User', value: 'user' },
  { key: 2, text: 'Admin', value: 'admin' },
];

export const approvalOptions = [
  { key: 1, text: 'Doesn\'t need approval', value: 'no_approval_needed' },
  { key: 2, text: 'Approver', value: 'approver' },
  { key: 3, text: 'Needs approval', value: 'needs_approval' },
];

export const INVALID_VALUE_ERROR = 'Variable role of type RoleTypeEnum! was provided invalid value';
export const MEMBERS_NOT_FOUND = 'No team members found.';
